<template>
  <div>
    <div class="content">
      <div v-if="getHome.RecipeCategories.length===0">
        <loading></loading>
      </div>
      <div v-else
           class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ getHome.Greeting }}</h2>
            <div class="receptdiv">
              <p class="sectiontitle2 text-muted">{{ $t('menu_home') }}</p>
            </div>
          </div>
        </div>
        <div class="row p-3">

          <div class="col-lg-6 m-b-10">
              <GenericHomeCard v-if="getHome.FirstCard"
                      :shiftTypeId="1"
                      :linkTo="getHome.FirstCard.Link"
                      :mainTitle="'home_infocard'"
                      :subTitle="getHome.FirstCard.Title"
                      :content="getHome.FirstCard.Text"
                      :buttonCaption="getHome.FirstCard.ButtonCaption"
              />
<!--            <button class="advicebutton confirm">
              <router-link class="text-white"
                           :to="{name: 'advicepage' , params: { advice_id: '7654d349-f5dc-4599-a8b0-fe8643065d16'}}">
                TEST
              </router-link>
            </button>-->


              <survey v-for="(survey, index) in orderedSurveys" :survey="survey" :index="survey.Id" :key="index"></survey>
              <GenericHomeCard v-if="getHome.LastCard"
                               :shiftTypeId="1"
                               :linkTo="getHome.LastCard.Link"
                               :mainTitle="'home_infocard'"
                               :subTitle="getHome.LastCard.Title"
                               :content="getHome.LastCard.Text"
                               :buttonCaption="getHome.LastCard.ButtonCaption"
              />
          </div>

          <statistics :username="getHome.UserFullName"
                      :stats="getHome.Stats"
                      class="col-lg-5 m-b-10">
          </statistics>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'
  import Survey from '../surveys/Survey.vue'
  import Statistics from './Statistics.vue'
  import Loading from '../utilities/Loading.vue'
  import GenericHomeCard from '../utilities/GenericHomeCard.vue'

  export default {
    components: {Survey, Statistics, Loading, GenericHomeCard},
    computed: {
      ...mapGetters([
        'getHome',
      ]),
      orderedSurveys () {
        return this.getHome.Surveys.sort( (a, b) => {return a.SortOrder - b.SortOrder})
      }
    },
    methods: {
      ...mapActions([
        'preLoadHome',
      ]),
    },
    created() {
      this.preLoadHome()
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue